import React, { forwardRef, useState, useEffect } from 'react';
import { SnackbarContent } from 'notistack';
import cn from 'classnames';
import { urlModifier } from 'swag-client-common/libs/url-modifier';
import { getLeftTime } from 'swag-common/utils/date-lib';
import CloseButton from '../../../../ui/close-button';
import { Countdown } from '../../../../../../customer/components/info/countdown';
import classes from './hot-products-notification.scss';
export const HotProductsNotification = /*#__PURE__*/forwardRef(function HotProductsNotification({
  typeName,
  productImage,
  productName,
  productLink,
  isLimitedEdition,
  inStockLE,
  expirationDateLE,
  onClose
}, ref) {
  const expirationDate = new Date(expirationDateLE !== null && expirationDateLE !== void 0 ? expirationDateLE : 0);
  const [leftTime, setLeftTime] = useState(getLeftTime(expirationDate));
  useEffect(() => {
    const timer = setInterval(() => {
      setLeftTime(getLeftTime(expirationDate));
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const showLEBar = leftTime > 0;
  return /*#__PURE__*/React.createElement(SnackbarContent, {
    className: cn(classes.container, {
      [classes.isLEContainer]: isLimitedEdition
    }),
    ref: ref
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.productImage
  }, /*#__PURE__*/React.createElement("img", {
    src: productImage,
    alt: "Product preview"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.info
  }, /*#__PURE__*/React.createElement("h5", null, typeName), /*#__PURE__*/React.createElement("p", {
    className: classes.productName
  }, productName), /*#__PURE__*/React.createElement("a", {
    className: cn(classes.link, {
      [classes.isLEColor]: isLimitedEdition
    }),
    href: urlModifier(productLink),
    target: "_blank",
    rel: "noreferrer noopener",
    onClick: onClose
  }, "View Product")), isLimitedEdition && /*#__PURE__*/React.createElement("div", {
    className: classes.LEBox
  }, showLEBar ? /*#__PURE__*/React.createElement(React.Fragment, null, inStockLE && /*#__PURE__*/React.createElement("span", {
    className: classes.LEqty
  }, "Only ", inStockLE, " in stock"), /*#__PURE__*/React.createElement("span", {
    className: classes.LECountdown
  }, /*#__PURE__*/React.createElement(Countdown, {
    leftTime: leftTime
  }))) : /*#__PURE__*/React.createElement("div", {
    className: classes.LENotAvailable
  }, "No longer available")), /*#__PURE__*/React.createElement(CloseButton, {
    className: cn(classes.closeButton, {
      [classes.isLEBGColor]: isLimitedEdition
    }),
    onClick: onClose,
    dataButton: "Close"
  }));
});